export const LOB_RAILS = 'rails';

export const EVENT_NAME_PAGE_RENDERED = 'page-rendered';
export const EVENT_TYPE_PAGE = 'page';

export const STORE_ID_MMT = 'MMT';
export const ORGANISATION_MMT = 'MMT';
export const BU_GROUND_TRANSPORT = 'ground_transport';
export const TRAFFIC_SOURCE_ORGANIC = 'organic';

export const PDT_SCHEMA_ID = 173469;
export const PDT_SCHEMA_NAME = 'mmt_rails_b2c_pdt_client_logging_v2';

export const RIS_LTS_SCHEMA_ID = 176533;
export const RIS_LTS_SCHEMA_NAME = 'base_event_ris_lts_logging_on_schema_blocks';

export const RIS_PDT_SCHEMA_ID = 164305;
export const RIS_PDT_SCHEMA_NAME = 'mmt_ris_b2c_pdt_client_logging';

export const PAGE_TYPE_FUNNEL = 'funnel';
export const FUNNEL_STEP_DETAIL = 'detail';
export const PAGE_NAME_HOME = 'home';

export const LOCUS_API_ENDPOINT = 'https://railways.makemytrip.com/api/mobile/search/getLocusId';
